import React from 'react'
import { Typography } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type FormattedValueProps = {
  content: boolean | number | string
  preserveWhitespace?: boolean
}

export default function FormattedValue({ content, preserveWhitespace = false }: FormattedValueProps) {
  const styles = useStyles()
  const contentToRender = getContentToRender(content)

  return (
    <Typography
      variant="caption"
      className={styles.boldedMultiLineCaption}
      style={preserveWhitespace ? PRESERVED_WHITESPACE : undefined}
    >
      {contentToRender}
    </Typography>
  )
}

const getContentToRender = (content: boolean | number | string): string | number => {
  switch (typeof content) {
    case 'boolean':
      return content ? 'Yes' : 'No'
    case 'number':
      return content
    case 'string':
      return content.trim() === '' ? '-' : content
    default:
      return '-'
  }
}

const PRESERVED_WHITESPACE = { whiteSpace: 'pre-wrap' } as const

const useStyles = makeStyles({
  boldedMultiLineCaption: {
    lineHeight: 1.3,
    fontWeight: 'bold',
  },
})
